import { computed, resolveComponent, createBlock, openBlock, withCtx, createVNode, createTextVNode, toDisplayString, normalizeProps, guardReactiveProps } from "vue";
import { VCard, VCardTitle, VCardText } from "vuetify/components/VCard";
import { VDivider } from "vuetify/components/VDivider";
import { VIcon } from "vuetify/components/VIcon";
import { VListSubheader, VListItem, VListItemTitle } from "vuetify/components/VList";
import { VMenu } from "vuetify/components/VMenu";
const _sfc_main = {
  __name: "SimpleNumberFilterItem",
  props: {
    modelValue: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: "mdi-numeric"
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const emits = __emit;
    const props = __props;
    const value = computed({
      get: () => props.modelValue,
      set: (value2) => {
        emits("update:modelValue", [value2]);
      }
    });
    return (_ctx, _cache) => {
      const _component_b_icon = resolveComponent("b-icon");
      const _component_b_text_edit = resolveComponent("b-text-edit");
      return openBlock(), createBlock(VMenu, {
        width: "350",
        offset: "8",
        class: "banza-boolean-filter-item",
        "close-on-content-click": false,
        location: "end"
      }, {
        activator: withCtx(({ props: activatorProps }) => [
          createVNode(VListItem, normalizeProps(guardReactiveProps(activatorProps)), {
            prepend: withCtx(() => [
              createVNode(_component_b_icon, {
                size: "20",
                class: "mr-2",
                icon: __props.icon
              }, null, 8, ["icon"])
            ]),
            append: withCtx(() => [
              createVNode(VIcon, null, {
                default: withCtx(() => _cache[1] || (_cache[1] = [
                  createTextVNode("mdi-chevron-right")
                ])),
                _: 1,
                __: [1]
              })
            ]),
            default: withCtx(() => [
              createVNode(VListItemTitle, null, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(__props.label), 1)
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1040)
        ]),
        default: withCtx(() => [
          createVNode(VCard, { class: "rounded-lg banza-lookup-filter-card" }, {
            default: withCtx(() => [
              createVNode(VCardTitle, { class: "pa-0" }, {
                default: withCtx(() => [
                  createVNode(VListSubheader, { class: "banza-filter--header py-3 pl-3" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(__props.label), 1)
                    ]),
                    _: 1
                  }),
                  createVNode(VDivider)
                ]),
                _: 1
              }),
              createVNode(VCardText, { class: "d-flex pa-2 ga-2 flex-nowrap" }, {
                default: withCtx(() => [
                  createVNode(_component_b_text_edit, {
                    modelValue: value.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
                    type: "number",
                    label: _ctx.$t("base.labels.value")
                  }, null, 8, ["modelValue", "label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
